import * as React from 'react';
import cx from 'classnames';

import './Button.styles.scss';

export type ButtonVariant = 'contained' | 'outlined' | 'text';

export type ButtonBsStyle = 'primary' | 'default';

export type ButtonBsSize = 'large' | 'small' | 'xsmall';

export type ButtonProps = React.PropsWithChildren<{
	variant?: ButtonVariant;
	text?: React.ReactNode;
	width?: string | number;
	maxWidth?: string | number;
	Component?: React.ElementType;
	bsStyle?: ButtonBsStyle;
	bsSize?: ButtonBsSize;
}> & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export const Button: React.FC<ButtonProps> = (props) => {
	const { 
		variant = 'contained', 
		text, 
		children, 
		width, 
		maxWidth = '100%', 
		className, 
		Component = 'button', 
		bsStyle = 'default', 
		bsSize,
		...otherProps 
	} = props;
	const commonProps = {
		title: text,
		style: { width, maxWidth },
		...otherProps
	};

	if (variant === 'text') {
		return (
			<Component 
				className={cx('Button', 'Button-text', className)} 
				{...commonProps}
			>
				{text || children}
			</Component>
		);
	}

	const bsStyleMap: Record<ButtonBsStyle, string> = {
		primary: 'btn-primary',
		default: 'btn-default'
	};

	const bsSizeMap: Record<ButtonBsSize, string> = {
		large: 'btn-lg',
		small: 'btn-sm',
		xsmall: 'btn-lg',
	}

	return (
		<button 
			className={cx('Button', 'btn', bsStyleMap[bsStyle], bsSize ? bsSizeMap[bsSize]: undefined, className)} 
			{...commonProps as React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>}
		>
			{text || children}
		</button>
	);
}